import { render, staticRenderFns } from "./boardBalanceDetail.vue?vue&type=template&id=67b77878&scoped=true&"
import script from "./boardBalanceDetail.vue?vue&type=script&lang=js&"
export * from "./boardBalanceDetail.vue?vue&type=script&lang=js&"
import style0 from "./boardBalanceDetail.vue?vue&type=style&index=0&id=67b77878&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b77878",
  null
  
)

export default component.exports